<template>
    <div>
        <template v-if="crud_employee === true && crud_employee !==null && permissions !== null && roles !== null">
            <form id="employeeForm" v-if="crud_employee" @submit.prevent="addEmployeePermissions">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Employee </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/employees" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Personal Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">2</span>
                            Job Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">5</span>
                            Time Off
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">6</span>
                            User Permission
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">7</span>
                            Welcome Options
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="user-permissions">
                            <label class="label block-label"> <span class="highlight-color"> Role </span> </label>
                            <div class="form-group">
                                <select v-on:change="getPermission($event)" v-model="form.role_id" name="role_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('role_id') }" v-if="roles != null">
                                    <option value="" selected>Select Role</option>
                                    <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                                        {{ role.name }}
                                    </option>
                                </select>
                                <has-error :form="form" field="role_id"></has-error>
                            </div>
                            <template v-if="permissions != null">
                                <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                    <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                    <div class="permissions-box">
                                        <div class="row">
                                            <div class="col-md-4 mb-2" v-for="child in permission" v-bind:key="child.id">
                                                <label class="check-holder ml-0">
                                                    <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                    <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.rolePermissions" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    role_id : '',
                    rolePermissions : [],
                    userPermissions : [],
                    id : this.$route.params.id
                }),
                role : {},
                permissions : null,
                roles: null,
                crud_employee: null
            }
        },
        methods: {
            addEmployeePermissions() {
                this.$Progress.start();
                this.form.post('/api/addEmployeeUserPermission/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success', 'Employee permissions added successfully');
                        this.$router.push('/addEmployeeWelcome/'+res.data.data.id);
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getEmployeePermissionsData(){
                this.$Progress.start();
                axios.get('/api/getEmployeePermissionsData')
                .then(res => {
                    if(res.status == 200){
                        this.roles = res.data.roles;
                        this.permissions = res.data.permissions;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getPermission(event) {
                this.$Progress.start();
                axios.get('/api/getEmployeeRolePermissionData/'+event.target.value)
                .then(res => {
                    if(res.status == 200){
                        this.form.rolePermissions = [];
                        $.each(res.data.permissions, (key, value) => {
                            this.form.rolePermissions.push(value.id);
                            this.form.userPermissions = this.form.rolePermissions;
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getEmployeeData() {
                axios.get('/api/editEmployee/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            if(res.data.user.wizard_cycle == 0){
                                this.$router.push('/addEmployeePersonalDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 1){
                                this.$router.push('/addEmployeeBasicDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 2){
                                this.$router.push('/addEmployeeTaxDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 3){
                                this.$router.push('/addEmployeePaymentDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 4){
                                this.$router.push('/addEmployeeTimeoff/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 5){
                                this.getEmployeePermissionsData();
                            }else if(res.data.user.wizard_cycle == 6){
                                this.$router.push('/addEmployeeWelcome/'+this.$route.params.id);
                            }
                        }
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_employee').then(result => {
                this.crud_employee = result.crud_employee;
            }).then(result => {
                if(this.crud_employee == true){
                    this.getEmployeeData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
